var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 2.5C9.08301 2.5 8.33301 3.25 8.33301 4.16667C8.33301 5.08333 9.08301 5.83333 9.99967 5.83333C10.9163 5.83333 11.6663 5.08333 11.6663 4.16667C11.6663 3.25 10.9163 2.5 9.99967 2.5ZM9.99967 14.1667C9.08301 14.1667 8.33301 14.9167 8.33301 15.8333C8.33301 16.75 9.08301 17.5 9.99967 17.5C10.9163 17.5 11.6663 16.75 11.6663 15.8333C11.6663 14.9167 10.9163 14.1667 9.99967 14.1667ZM9.99967 8.33333C9.08301 8.33333 8.33301 9.08333 8.33301 10C8.33301 10.9167 9.08301 11.6667 9.99967 11.6667C10.9163 11.6667 11.6663 10.9167 11.6663 10C11.6663 9.08333 10.9163 8.33333 9.99967 8.33333Z",
    fill: "#149cce"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreGray);
export default __webpack_public_path__ + "static/media/moreGray.b69616d4138a7d916e4f29f3f6c85f79.svg";
export { ForwardRef as ReactComponent };